import type { RewardsBreakdownQuery$data } from '@/__generated__/RewardsBreakdownQuery.graphql'
import { formatNumber } from '@ourzora/utils'
import * as React from 'react'
import { Image, Text, View } from 'reshaped'
import styles from './RewardsBreakdown.module.css'

type RewardCategory = keyof RewardsBreakdownQuery$data['zoraTokenAllocation']

export interface RewardCardProps {
  reward: {
    id: RewardCategory
    title: string
    description: string
    imagePath: string
    amount: number
  }
  inactive?: boolean
}

export const RewardCard = ({ reward, inactive = false }: RewardCardProps) => {
  const formattedAmount = reward.amount ? formatNumber(Math.floor(reward.amount)) : '0'

  const [showTooltip, setShowTooltip] = React.useState(false)

  return (
    <View
      height={{ s: '156px', m: '178px' }}
      position="relative"
      attributes={{
        onMouseEnter: () => setShowTooltip(true),
        onMouseLeave: () => setShowTooltip(false),
      }}
    >
      <View
        position="relative"
        borderRadius="xlarge"
        borderColor="neutral-faded"
        className={`${styles.rewardCard} ${inactive ? styles.inactiveCard : ''}`}
      >
        <View gap={2} align="center" padding={4}>
          <View width={18} height={18} padding={1}>
            <Image src={reward.imagePath} alt={reward.title} height="100%" width="100%" />
          </View>
          <Text
            variant="body-2"
            weight="semibold"
            align="center"
            maxLines={1}
            color={inactive ? 'neutral-faded' : 'primary'}
          >
            {reward.title}
          </Text>
          <Text variant="body-3" color="neutral-faded" align="center">
            +{formattedAmount} $ZORA
          </Text>
        </View>
      </View>

      {showTooltip && (
        <View
          position="absolute"
          className={styles.customTooltip}
          minWidth="200px"
          maxWidth="220px"
          zIndex={2}
          borderRadius="large"
          padding={3}
          borderColor="neutral-faded"
        >
          <Text variant="body-3">{reward.description}</Text>
        </View>
      )}
    </View>
  )
}
